import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { ChipModule } from 'primeng/chip';
import { IconFieldModule } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { HeadingComponent } from '../../../../../shared/components/heading/heading.component';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchMarkets, SearchMarket, SearchReviewerQueryParams, SearchReviewerResponse, Reviewer, UpdateUserStatus } from '../people.interface';
import { PeopleService } from '../../../../../shared/services/people.service';
import { ConfigurationService } from '../../../../../shared/services/configuration.service';
import { constants } from '../../../../../shared/constants/constants';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmationDialogService } from '../../../../../shared/services/confirmation-dialog.service';
import { ToastService } from '../../../../../shared/services/toast.service';
import { UserService } from '../../../../../shared/services/user.service';
import { DeleteUserByFirm, UserClientVm } from '../../../../../store/user/user.interface';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RatingModule } from 'primeng/rating';
import {CredentialingComponent} from './modals/credentialing/credentialing.component'
import { ReviewerDetailDialogService } from '../../../../../shared/services/reviewer-detail-dialog.service';
import { DeleteUserConfirmation } from '../all/modals/delete/delete-user-confirmation.component';
import { TooltipModule } from 'primeng/tooltip';
import { PipesModule } from '../../../../../shared/pipes/pipes.module';
import { HelperService } from '../../../../../shared/services/helper.service';
import { TabViewModule } from 'primeng/tabview';
@Component({
    selector: 'app-pending-candidates',
    imports: [DropdownModule, ButtonModule, FormsModule, TabViewModule, RatingModule, ChipModule, IconFieldModule, InputIconModule, InputSwitchModule, HeadingComponent, InputTextModule, TableModule, CommonModule, TooltipModule, PipesModule],
    templateUrl: './pending-candidates.component.html',
    standalone: true,
    styleUrl: './pending-candidates.component.scss'
})
export class PendingCandidatesComponent {
  reviewerCount: number = 0;
  searchMarkets: any = [];
  expiredCredentialsCandidateView: boolean = false;  
  reviewers: Reviewer[] = [];
  newCredentialReviewers: Reviewer[] = [];
  newCredentialReviewerCount: number = 0;
  pageTitle: string;
  filterStaffedCandidates: boolean = true;
  userObject!: UserClientVm;
  ref: DynamicDialogRef | undefined;
  infoRef: DynamicDialogRef | undefined;
  isPwcEnabled = false;

  constructor(private route: ActivatedRoute, private peopleService: PeopleService, private configurationService: ConfigurationService,
    private confirmationDialogService: ConfirmationDialogService, private toast: ToastService, private userService: UserService,
    public dialogService: DialogService,private reviewerDetailDialogService:ReviewerDetailDialogService, private router:Router,
    public helperService: HelperService
  ) {
    this.isPwcEnabled = this.configurationService.getPwcFlag();
    this.expiredCredentialsCandidateView = this.router.url.includes('expired-credential-candidates');
    this.pageTitle = this.expiredCredentialsCandidateView? "Expired Credentials" : "Pending Candidates";
    this.userObject = this.userService.getSessionUser();
  }

  gotoCredentials(){
    this.router.navigateByUrl('/client/people/expired-credential-candidates')
  }

  onExpiredStaffedFilterToggleSwitch(){
    this.getReviewers({first:0, rows:10});
    this.getNewCredentialReviewersList({first:0, rows:10});
  }

  getSearchMarket() {
    const searchMarkets: SearchMarkets = this.route.snapshot.data['searchMarket'];
    searchMarkets.map((d: SearchMarket) => {
      this.searchMarkets.push(d._id);
    })
  }
    
  getReviewers(event?: any) {
    const offset = event.first;
    const limit = event.rows;
    const queryParams: SearchReviewerQueryParams = {
      sortOrder: constants.sortingOrder.descending,
      offset: offset,
      limit: limit,
      searchOn: 'all',
    };
    let subscribedList;
    if(this.expiredCredentialsCandidateView){
      queryParams.filterStaffedCandidates = this.filterStaffedCandidates;
      subscribedList = this.peopleService.getExpiredCredentialCandidateList(queryParams, this.userService.getUserFirmId())
    } else{
      subscribedList = this.peopleService.getPendingCandidateList(queryParams, this.userService.getUserFirmId())
    }
    subscribedList.subscribe((response: SearchReviewerResponse) => {
      this.reviewers = response.users.map((user: Reviewer) => {
        return {
          ...user,
          defaultTenantRating: user.tenants && user.tenants.length > 0 && user.tenants[0].defaultRatings,
        }
      });
      this.reviewerCount = response.count;
    })
  }

  getNewCredentialReviewersList(event?: any) {
    const offset = event.first;
    const limit = event.rows;
    const queryParams: SearchReviewerQueryParams = {
      sortOrder: constants.sortingOrder.descending,
      offset: offset,
      limit: limit,
      searchOn: 'all',
    };
    this.peopleService.getNewCredentialCandidateList(queryParams, this.userService.getUserFirmId()).subscribe((response: SearchReviewerResponse) => {
      this.newCredentialReviewers = response.users.map((user: Reviewer) => {
        return {
          ...user,
          defaultTenantRating: user.tenants && user.tenants.length > 0 && user.tenants[0].defaultRatings,
        }
      });
      this.newCredentialReviewerCount = response.count;
    });
  }

  handleLazyLoad(event: any, loadFunction: string) {
    switch (loadFunction) {
      case 'getReviewers':
        this.getReviewers(event);
        break;
      case 'getNewCredentialReviewersList':
        this.getNewCredentialReviewersList(event);
        break;
      default:
        console.warn(`Unknown load function: ${loadFunction}`);
    }
  }

  approveReviewer($event: Event, reviewer: Reviewer) {
    // Check if reviewer has pending credentials/education records
    // MP-5636: match on the family ROOT - a reviewer's tenant entry is keyed there, while the acting firm may be a CHILD.
    const currentTenant = reviewer.tenants.find(tenant => tenant.firm._id === this.userService.getFamilyRootFirmId());
    
    let hasPendingCredentials = false;
    let hasPendingEducations = false;
    
    // Check for pending credentials
    if (currentTenant && currentTenant.credentials && currentTenant.credentials.length > 0) {
      const pendingCredentials = currentTenant.credentials.filter((credential: any) => credential.secureBackgroundStatus === 'N/A');
      hasPendingCredentials = pendingCredentials.length > 0;
    }
    
    // Check for pending educations
    if ((reviewer as any).profile && (reviewer as any).profile.educations && (reviewer as any).profile.educations.length > 0) {
      const pendingEducations = (reviewer as any).profile.educations.filter((education: any) => education.secureBackgroundResult === 'N/A');
      hasPendingEducations = pendingEducations.length > 0;
    }
    
    if (hasPendingCredentials || hasPendingEducations) {
      // Show alert for pending credentials or educations
      this.confirmationDialogService.confirm({
        target: $event.target as EventTarget,
        message: `${reviewer.firstName} ${reviewer.lastName} has credentials or education records that have not been reviewed and approved/denied. Please take action on all credential and education records prior to adding ${reviewer.firstName} ${reviewer.lastName} to your eligible workforce.`,
        header: 'Additional review required',
        acceptIcon: "none",
        rejectIcon: "none",
        acceptLabel: "View credentials",
        rejectLabel: "Okay",
        acceptButtonStyleClass: "p-button p-button-primary mt-3",
        rejectButtonStyleClass: "p-button-text mt-3",
        width: '35vw',
        contentStyle: { overflow: 'auto', padding: '1.5rem' },
        breakpoints: {
          '960px': '60vw',
          '640px': '80vw'
        },
        closable: true,
        draggable: false,
        accept: () => {
          // Open reviewer dialog to view credentials
          this.showInfoDialog($event, reviewer);
        }
      });
      return;
    }
    
    // If no pending credentials, proceed with normal approval confirmation
    const mesg = `You are about to approve ${reviewer.firstName} ${reviewer.lastName}. Are you sure?`
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: mesg,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        this.userService.approveUser(reviewer._id).subscribe((response: any) => {
          this.getReviewers({ first: 0, rows: 10 });
          this.getNewCredentialReviewersList({ first: 0, rows: 10 });
          this.toast.showSuccess('Candidate Approved Successfully')
        })
      }
    });
  }

  isReviewerApproveDisable(reviewer: Reviewer) {
    // MP-5636: match on the family ROOT - a reviewer's tenant entry is keyed there, while the acting firm may be a CHILD.
    const tenant = reviewer.tenants.find(tenant => tenant.firm === this.userService.getFamilyRootFirmId());
    return (tenant && tenant.reviewerStatus !== constants.userVerificationStatus.pendingAdminVerification);

  }
  showInfoDialog($event: Event,reviewer: Reviewer) {
    const data = {
      reviewer: reviewer,
      expiredCredentialsCandidateView:this.expiredCredentialsCandidateView
    }
    this.infoRef = this.dialogService.open(CredentialingComponent, {
      data: data,
      header: 'Credentialing and education',
      width: 'calc(100vw - 100px)',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      }
    });
    this.infoRef.onClose.subscribe((resp: any) => {
      this.getReviewers({ first: 0, rows: 10 });
      this.getNewCredentialReviewersList({ first: 0, rows: 10 });
      if (resp && resp.from) {
        const from = resp.from
        if(from === 'info'){
          this.approveReviewer($event, reviewer);
        }else if( from === 'backgroundCheck' ||  from === 'nsc'){
          this.invokeBackground($event, reviewer,resp.data, from);
        }
      }
  });
  }
  invokeBackground($event: Event, reviewer: Reviewer, data:any, from:string) {
    const mesg = `You are about to send following background check request for ${data.type}. Are you sure? `
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: mesg,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        const requestObject = { type: data.type, typeId: data._id || undefined };
        if(from === 'nsc'){
          this.userService.invokeEducationBackgroundCheck(reviewer._id,requestObject).subscribe((response: any) => {
            this.toast.showSuccess('Education/degree verification has been successfully submitted')
            this.showInfoDialog($event, reviewer);
          })
        }else{
          this.userService.invokeBackgroundCheck(reviewer._id,requestObject).subscribe((response: any) => {
            this.toast.showSuccess('Background Check invoked successfully')
          })
        }
       
      }
    });
  }
  openReviewerDialog(id:string){
    this.reviewerDetailDialogService.openDialog(id);
  }

  showDeleteReviewerConfirmation($event:Event,reviewer:Reviewer) {
    const data = {
      heading: `Are you sure you want to archive ${reviewer.firstName} ${reviewer.lastName}`,
      from: 'deleteReviewer',
      textAreaHeading: 'Comment',
      isCommentOptional: true
    }
    $event.stopPropagation();
      this.ref = this.dialogService.open(DeleteUserConfirmation, {
          data: data,
          header: 'Confirmation',
          width: '30vw',
          contentStyle: { overflow: 'auto' },
          breakpoints: {
              '960px': '75vw',
              '640px': '90vw'
          }
      });

      this.ref.onClose.subscribe((data: DeleteUserByFirm) => {
          
          if (data) {
            const payload: DeleteUserByFirm = {
              reason : data.reason,
              comments: data.comments,
              firm : this.userService.getUserFirmId()
            }
            this.userService.deleteUserByFirm(reviewer._id, payload).subscribe((response: any) => {
              this.getReviewers({ first: 0, rows: 10 });
              this.getNewCredentialReviewersList({ first: 0, rows: 10 });
              this.toast.showSuccess('User archived successfully')
            })
          }
          
      });
  }
}